const mutations = {
  SET_FEATURES(state, features) {
    state.features = features;
  },

  SET_AVAILABLE_FEATURES(state, featuresAvailable) {
    state.featuresAvailable = featuresAvailable;
  },
};

export default mutations;
